import React from "react";
import "./Loader.css"; // import the css file

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
